module.exports = __webpack_public_path__ + "static/media/Effra-Medium.9e556a44.woff2";